var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserRadioSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.44078 25.7748C9.00358 24.212 11.1232 23.334 13.3333 23.334H26.6667C28.8768 23.334 30.9964 24.212 32.5592 25.7748C34.122 27.3376 35 29.4572 35 31.6673V35.0007C35 35.9211 34.2538 36.6673 33.3333 36.6673C32.4129 36.6673 31.6667 35.9211 31.6667 35.0007V31.6673C31.6667 30.3412 31.1399 29.0695 30.2022 28.1318C29.2645 27.1941 27.9927 26.6673 26.6667 26.6673H13.3333C12.0073 26.6673 10.7355 27.1941 9.7978 28.1318C8.86012 29.0695 8.33333 30.3412 8.33333 31.6673V35.0007C8.33333 35.9211 7.58714 36.6673 6.66667 36.6673C5.74619 36.6673 5 35.9211 5 35.0007V31.6673C5 29.4572 5.87797 27.3376 7.44078 25.7748Z",
    fill: "#9F9978"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 6.66732C17.2386 6.66732 15 8.90589 15 11.6673C15 14.4287 17.2386 16.6673 20 16.6673C22.7614 16.6673 25 14.4287 25 11.6673C25 8.90589 22.7614 6.66732 20 6.66732ZM11.6667 11.6673C11.6667 7.06494 15.3976 3.33398 20 3.33398C24.6024 3.33398 28.3334 7.06494 28.3334 11.6673C28.3334 16.2697 24.6024 20.0007 20 20.0007C15.3976 20.0007 11.6667 16.2697 11.6667 11.6673Z",
    fill: "#9F9978"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRadioSelect);
export default __webpack_public_path__ + "static/media/user_radio_select.ccc76cd2c8789e27b9ee2c83d3992d05.svg";
export { ForwardRef as ReactComponent };